
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { message, Collapse, Button, Skeleton, Result } from 'antd';
import { RiUserSettingsLine } from 'react-icons/ri';
import { IoIosTimer } from 'react-icons/io';
import { AiOutlineFileSearch, AiOutlineFire } from 'react-icons/ai';
import { CampaignGetSingle } from '../../apis/Influencer/Campaigns/CampaignGetSingle';
import { useGlobalState } from '../../store/state';
import InfluencerBaseLayoutComponent from '../../components/Layout/Influencer/InfluencerBaseLayoutComponent';
import InfluencerTopSubHeaderComponent from '../../components/Influencers/Common/InfluencerTopSubHeaderComponent';
import './InfluencerCampaignDetailsPage.styles.scss';
import CampaignProgressComponent from '../../components/Influencers/Campaign/Details/CampaignProgressComponent';
import CampaignCreativeCollectionForm from '../../components/Influencers/Campaign/Creatives/CampaignCreativeCollectionForm';

const { Panel } = Collapse;
const InfluencerCampaignCreativesPage = () => {
  const history = useHistory();
  const params = useParams();
  const [user] = useGlobalState('user');
  const [loading, setLoading]=useState(true);
  const [camp, setCamp] = useState({});
  const getCampaignDetails = () =>{
    CampaignGetSingle(
      user.accessToken,
      params.campaignId,
    ).then(({ status, response })=>{
      console.log('API: res-> campaign single ==>', response);
      if (status === 200) {
        setCamp({
          ...response,
        });
        if (response.connectionStatus === 'review' || response.connectionStatus === 'active' || response.connectionStatus === 'approved') {
          history.push(`/influencer/campaigns/${params.campaignId}/creatives/review`); // redirect to review posts
        } else if (response.connectionStatus === 'assigned') {
          message.info('Please accept campaign first');
          history.push(`/influencer/campaigns/${params.campaignId}`); // redirtect to details of campaign
        } else {}
        setLoading(false);
      } else {
        message.error('There is some error in getting Campaign list');
      }
    });
  };
  useEffect(() =>{ // load all list first time
    getCampaignDetails();
  }, []);

  // const creativesSubmission = (value) => {
  //     console.log("creative submit",value)
  // }


  return (
    <InfluencerBaseLayoutComponent>
      <InfluencerTopSubHeaderComponent className="py-2 sticky">
        <div className="d-flex flex-wrap align-items-center">
          <div className="col-md-6">
            <p className="m-0"><strong>Upload Creatives</strong></p>
          </div>
          {/* <div className="col-md-6 text-right">
                        <Button
                            className="common_button outlined py-1"
                            title="Submit your campaigns"
                            htmlType="submit"
                            onClick={creativesSubmission}
                        >Submit All Creatives</Button>
                    </div> */}
        </div>
      </InfluencerTopSubHeaderComponent>
      <div style={{ padding: 15 }}>
        <div className="campaign_details pt-1">
          <div className="row">
            <div className="col-md-8 pr-2">
              {loading ? (
                <div>
                  <Skeleton active
                    paragraph={{ rows: 6 }}/>
                </div>
              ):(
                camp.campaignInfo && camp.campaignInfo.deliverables.length ?
                  <CampaignCreativeCollectionForm
                    campId={camp.campaignInfo._id}
                    deliverables={camp.campaignInfo.deliverables}
                    // creativesSubmission={creativesSubmission}
                  />:
                  <div>
                    <Result
                      title='No submission Accepted'
                      subTitle="You Don't have any permission to submit creatives to this campaign"
                      extra={(<Link to="/influencer/campaigns"
                        className="common_button">Go Back Campaigns</Link>)}
                    />
                  </div>
              )
              }
            </div>
            <div className="col-md-4 pl-2">
              {
                camp.campaignInfo?
                  <CampaignProgressComponent
                    name={camp.campaignInfo.name}
                    startdate={camp.campaignInfo.startdate}
                    campId={camp.campaignInfo._id}
                  />:
                  <div>No Campaign Details present</div>
              }
            </div>
          </div>
        </div>
      </div>
    </InfluencerBaseLayoutComponent>
  );
};

export default InfluencerCampaignCreativesPage;
